import "../../styles/components/viewingForm.scss";
import { Collapse, Descriptions } from "antd";

const { Panel } = Collapse;

function ViewingForm({ viewingDataConfig, data }) {
  const descData = viewingDataConfig?.map((section) => {
    const updatedCollapseItems = section?.collapseItems
      ?.filter((item) => {
        if (!item?.hideIfEmpty) return true;
        // Don't hide a field flagged as edited while still pending, even if
        // it was edited down to empty — that's still meaningful to show.
        // (Mirrors the same pending-only gating the "Edited" badge itself uses.)
        if (data?.status === "pending" && data?.edited_fields?.includes(item?.name)) {
          return true;
        }
        const rawValue = data[item?.name];
        return rawValue !== null && rawValue !== undefined && rawValue !== "";
      })
      .map((item) => {
        const rawValue = data[item?.name] ?? null;
        const children = item?.render ? item.render(rawValue, data) : rawValue;
        const label =
          typeof item?.label === "function" ? item.label(data) : item?.label;

        return {
          ...item,
          label,
          children,
        };
      });

    return {
      ...section,
      collapseItems: updatedCollapseItems,
    };
  });

  return (
    <>
      {descData?.map((collapseItems) => {
        return (
          <>
            <div className="viewform">
              {/* NOTE: MAKE THE KEY TO 1 IN SENDING THE PROPS IF YOU WANT IT ACTIVE, 0 OTHERWISE */}
              <Collapse defaultActiveKey={[1]} bordered={false}>
                <Panel
                  header={collapseItems?.collapseName}
                  key={collapseItems?.key}
                >
                  <Descriptions
                    size={"small"}
                    bordered={true}
                    column={1}
                    items={collapseItems?.collapseItems}
                  />
                </Panel>
              </Collapse>
            </div>
          </>
        );
      })}
    </>
  );
}

export default ViewingForm;
